/* src/app/layout/sub-top-bar/sub-top-bar.component.css */
body {
  font-family:
    Roboto,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Oxygen,
    Ubuntu,
    Cantarell,
    "Open Sans",
    "Helvetica Neue",
    sans-serif;
}
::ng-deep .navbar1 .mat-tab-label-content {
  color: white;
}
.mat-ink-bar {
  background-color: white !important;
  height: 4px !important;
  margin-right: 10px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
::ng-deep .mat-mdc-tab-header {
  border: 0 !important;
  padding-left: 20px;
}
.spacer {
  background: white;
  height: 2px;
}
.sub-navBar {
  background-color: var(--subheader-color);
  color: var(--light-text);
}
::ng-deep .mat-mdc-tab-nav-bar {
  padding: 0;
  padding-left: 20px;
  color: white;
  border: 0px;
}
::ng-deep .mat-mdc-tab-link {
  color: white;
}
::ng-deep .mat-mdc-tab-link:hover {
  color: white;
  opacity: 1;
  text-decoration: none;
}
.nositesfiller {
  height: 35px;
}
/*# sourceMappingURL=sub-top-bar.component.css.map */
